import { Column } from "@/constants/pipeline";
import * as React from "react";

type CellProps = {
  columns: Column[];
  index: number;
  children: React.ReactNode;
  sortBy?: string;
  highlightColor?: string;
};

export const Cell: React.FC<CellProps> = ({ columns, index, children, sortBy, highlightColor = "#FBFAFF" }) => {
  const column = columns[index];
  if (!column) return null;

  const alignClass = column.align === "center" ? "text-center" : column.align === "right" ? "text-right" : "text-left";

  const paddingClass = column.reducePadding ? "px-3 md:px-1.5 py-3" : "px-3 py-3";

  const isSorted = sortBy === column.key;

  return (
    <td
      colSpan={column.colspan}
      className={`${paddingClass} truncate align-middle text-sm ${alignClass} ${
        column.borderRight ? "border-r border-solid border-slate-200" : ""
      }`}
      style={isSorted ? { backgroundColor: highlightColor } : undefined}
    >
      {children}
    </td>
  );
};
